import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Row, Col, ListGroup, Button, Card } from 'react-bootstrap';
import { FaTrash } from 'react-icons/fa';
import Message from '../components/Message';
import { addToCart, removeFromCart } from '../slices/cartSlice';

const AdminForm = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const cart = useSelector((state) => state.cart);
  const { cartItems } = cart;

  const addToCartHandler = (product, qty) => {
    dispatch(addToCart({ ...product, qty }));
  };

  const removeFromCartHandler = (id) => {
    dispatch(removeFromCart(id));
  };
  const insulistbag = () => {
    navigate('/login?redirect=/admin/insurancelist');
  };
    
  const insubag = () => {
    navigate('/login?redirect=/insurancesform');
  };
  const productlisthandle = () => {
    navigate('/login?redirect=/admin/productlist');
  };
  const salebag = () => {
    navigate('/login?redirect=/admin/salelist');
  };
  const supplybag = () => {
    navigate('/login?redirect=/admin/supplylist');
  };
  const stockbag = () => {
    navigate('/login?redirect=/admin/stocklist');
  };
  const openingstockbag = () => {
    navigate('/login?redirect=/admin/openingstocklist');
  };
  const Transferbag = () => {
    navigate('/login?redirect=/admin/transferlist');
  };

  const Expensebag = () => {
    navigate('/login?redirect=/admin/expenselist');
  };
  const Paymentbag = () => {
    navigate('/login?redirect=/admin/paymentlist');
  };
  const notebag = () => {
    navigate('/login?redirect=/admin/baglist');
  };
  const Cashbag = () => {
    navigate('/login?redirect=/netcash');
  };
  const Bankbag = () => {
    navigate('/login?redirect=/bankuserlist');
  };
  const Landlordbag = () => {
    navigate('/login?redirect=/admin/landlordlist');
  };
  const Tenantbag = () => {
    navigate('/login?redirect=/admin/tenantlistscreen');
  };
  
  const Rentbag = () => {
    navigate('/login?redirect=/admin/rentlistscreen');
  };
  
  const Customerbag = () => {
    navigate('/login?redirect=/admin/customerlist');
  };
  const Supplierbag = () => {
    navigate('/login?redirect=/admin/supplierlist');
  };
    const SupplySummarybag = () => {
    navigate('/login?redirect=/admin/supplysummary');
  };
  const SupplyInvoiceSummarybag = () => {
    navigate('/login?redirect=/admin/supplyinvoicesummary');
  };
  const AdminScreen = () => {
    navigate('/login?redirect=/admin/adminuserscreen');
  };

const StockReport = () => {
    navigate('/login?redirect=/stockreport');
  };

const DateExpense = () => {
    navigate('/login?redirect=/stockdatexpenses');
  };

const ExpenseInvoice = () => {
    navigate('/login?redirect=/admin/expenseinvoices');
  };

const InvoiceSummary = () => {
    navigate('/login?redirect=/admin/supplyinvoicesummary');
  };
const InvoiceSummaryTwo = () => {
    navigate('/login?redirect=/admin/incomeexpensecategories');
  };
const SupplierBalance = () => {
    navigate('/login?redirect=/admin/supplierbalance');
  };
const ExpenseCategory = () => {
    navigate('/login?redirect=/admin/expensecategory');
  };
const IncomeCategory = () => {
    navigate('/login?redirect=/admin/incomecategory');
  };
const Cashflow = () => {
    navigate('/login?redirect=/alltotal');
  };
const OrderList = () => {
    navigate('/login?redirect=/admin/orderlist');
  };
const BankBag = () => {
    navigate('/login?redirect=/admin/depositlist');
  };

const StockBulkUpdate = () => {
    navigate('/login?redirect=/admin/stockbulkeditscreen');
  };
  const BalanceByUserbag = () => {
    navigate('/login?redirect=/balancebyuseradminscreen');
  };
  

  return (
    <Row>
      <Col md={8}>
        <h1 style={{ marginBottom: '20px' }}>Browse Pages</h1>
        {cartItems.length === 0 ? (
          <Message>
            Go<Link to="/house/HomeScreen"> Back</Link>
          </Message>
        ) : (
          <ListGroup variant="flush">
            {cartItems.map((item) => (
              <ListGroup.Item key={item._id}>
                <Row>
                  <Col md={2}>
                    {item.images?.length > 0 && (
                      <img
                        src={item.images[0]}
                        alt="Thumbnail"
                        className="thumbnail-img me-2"
                        style={{
                          width: '40px',
                          height: '40px',
                          objectFit: 'cover',
                        }}
                      />
                    )}
                  </Col>
                  <Col md={3}>
                    <Link to={`/product/${item._id}`}>{item.name}</Link>
                  </Col>
                  <Col md={2}>${item.price}</Col>
                  <Col md={2}>
                    <Button
                      type="button"
                      variant="light"
                      onClick={() =>
                        addToCartHandler(item, item.qty > 1 ? item.qty - 1 : 1)
                      }
                      disabled={item.qty === 1}
                    >
                      -
                    </Button>
                    <span className="mx-2">{item.qty}</span>
                    <Button
                      type="button"
                      variant="light"
                      onClick={() =>
                        addToCartHandler(item, item.qty + 1)
                      }
                      disabled={item.qty === item.countInStock}
                    >
                      +
                    </Button>
                  </Col>
                  <Col md={2}>${item.price * item.qty}</Col>
                  <Col md={1}>
                    <Button
                      type="button"
                      variant="light"
                      onClick={() => removeFromCartHandler(item._id)}
                    >
                      <FaTrash />
                    </Button>
                  </Col>
                </Row>
              </ListGroup.Item>
            ))}
          </ListGroup>
        )}
      </Col>
      <Col md={4}>
        <Card>
          <ListGroup variant="flush">
            <ListGroup.Item>
              <h2>
                Subtotal ({cartItems.reduce((acc, item) => acc + item.qty, 0)})
                items
              </h2>
              $
              {cartItems
                .reduce((acc, item) => acc + item.qty * item.price, 0)
                .toFixed(2)}
            </ListGroup.Item>
            <ListGroup.Item>
              <Button
                type="button"
                className="btn-block"
                style={{display: "none"}}
                disabled={cartItems.length === 0}
                onClick={productlisthandle}
              >
                ProductList
              </Button>
              <Button
                type="button"
                className="btn-block"
                
                onClick={productlisthandle}
              >
                ProductList
              </Button>
              <Button
                type="button"
                className="btn-block"
                
                onClick={salebag}
              >
                Sales
              </Button>
              <Button
                type="button"
                className="btn-block"
                
                onClick={supplybag}
              >
               Purchases
              </Button>
              <Button
                type="button"
                className="btn-block"
            
                onClick={Transferbag}
              >
                Transfers
              </Button>
              <Button
                type="button"
                className="btn-block"
                
                onClick={stockbag}
              >
                Stocks
              </Button>
              
              <Button
                type="button"
                className="btn-block"
                
                onClick={openingstockbag}
              >
                OpeningStock
              </Button>
              <Button
                type="button"
                className="btn-block"
                
                onClick={Expensebag}
              >
                Income / Expenses
              </Button>
              <Button
                type="button"
                className="btn-block"
                
                onClick={Paymentbag}
              >
                Payments
              </Button>
              <Button
                type="button"
                className="btn-block"
                
                onClick={notebag}
              >
                General Notes
              </Button>
              <Button
                type="button"
                className="btn-block"
                
                onClick={Cashbag}
              >
                Cash Collected
              </Button>
              <Button
                type="button"
                className="btn-block"
                
                onClick={Bankbag}
              >
                Bank- Staffpage
              </Button>
              <Button
                type="button"
                className="btn-block"
                
                onClick={Customerbag}
              >
                Customerlist
              </Button>
              <Button
                type="button"
                className="btn-block"
                
                onClick={Tenantbag}
              >
                Tenantlist
              </Button>
              <Button
                type="button"
                className="btn-block"
                
                onClick={Rentbag}
              >
                Rentlist
              </Button>

              
              <Button
                type="button"
                className="btn-block"
                
                onClick={Landlordbag}
              >
                Landlordlist
              </Button>
              
              <Button
                type="button"
                className="btn-block"
                
                onClick={Supplierbag}
              >
                Supplierlist
              </Button>
              <Button
                type="button"
                className="btn-block"
                
                onClick={SupplySummarybag}
              >
                General Supply Summary
              </Button>
              <Button
                type="button"
                className="btn-block"
                
                onClick={SupplyInvoiceSummarybag}
              >
                Supply Summary
              </Button>
              <Button
 type="button"
 className="btn-block"
                
 onClick={AdminScreen}
>
ChangeUserRole
</Button> 

<Button
 type="button"
 className="btn-block"
                
 onClick={StockReport}
>
Credit Sales
</Button>      

<Button
 type="button"
 className="btn-block"
                
 onClick={DateExpense}
>
Stock-Cash-Analysis
</Button>      
<Button
 type="button"
 className="btn-block"
                
 onClick={ExpenseInvoice}
>
Invoice
</Button>      
     
<Button
 type="button"
 className="btn-block"
                
 onClick={InvoiceSummary}
>
InvoiceNum
</Button>   


<Button
 type="button"
 className="btn-block"
                
 onClick={InvoiceSummaryTwo}
>
IncEx Category
</Button>   
<Button
 type="button"
 className="btn-block"
                
 onClick={SupplierBalance}
>
SupplierBalance
</Button>  
<Button
 type="button"
 className="btn-block"
                
 onClick={ExpenseCategory}
>
Income-Expense Categories
</Button>   


<Button
 type="button"
 className="btn-block"
                
 onClick={IncomeCategory}
>
CashCollected-Category
</Button>   

<Button
 type="button"
 className="btn-block"
                
 onClick={Cashflow}
>
Cashflow
</Button>  
 
<Button
 type="button"
 className="btn-block"
                
 onClick={OrderList}
>
OrderList
</Button>   

<Button
 type="button"
 className="btn-block"
                
 onClick={BankBag}
>
Bank
</Button>



<Button
 type="button"
 className="btn-block"
                
 onClick={StockBulkUpdate}
>
Stock Bulk Update
</Button>
             <Button
                type="button"
                className="btn-block"
                disabled={cartItems.length === 0}
                onClick={insubag}
              >
                Proceed To InsuForm
              </Button>
              <Button
                type="button"
                className="btn-block"
                
                onClick={insulistbag}
              >
                Insurance Bills
              </Button>
              <Button
                type="button"
                className="btn-block"
                
                onClick={BalanceByUserbag}
              >
                Daily NetBalances
              </Button>

            </ListGroup.Item>
          </ListGroup>
        </Card>
      </Col>
    </Row>
  );
};

export default AdminForm;